import { ItemType } from '../../inventory/type/item'
import { FilterKind } from './filter-catalog'

export enum FilterOverrideScope {
  Category = 'Category',
  Subcategory = 'Subcategory',
  Subcategory2 = 'Subcategory2',
  Vendor = 'Vendor',
}

export enum FilterOverrideAction {
  Add = 'Add',
  Remove = 'Remove',
}

export interface FilterDescriptorView {
  key: string
  label: string
  kind: FilterKind
}

export interface FilterBaseConfigEntryView {
  filterKey: string
  label: string
  kind: FilterKind
  enabled: boolean
  displayOrder: number
}

export interface FilterOverrideScopeTargetView {
  id: number
  title?: string | null
  /**
   * Ancestor titles ordered root-first. Empty for Category- and Vendor-scoped
   * targets; one entry for Subcategory targets (the parent Category), two for
   * Subcategory2 targets (Category → Subcategory).
   */
  breadcrumb: string[]
}

export interface FilterOverrideRuleView {
  id: number
  filterKey: string
  action: FilterOverrideAction
  displayOrder: number
}

export interface FilterOverrideView {
  id: number
  productType: ItemType
  scopeType: FilterOverrideScope
  scopeId: number
  name?: string | null
  target?: FilterOverrideScopeTargetView | null
  rules: FilterOverrideRuleView[]
}

export interface SaveBaseConfigEntryInput {
  filterKey: string
  displayOrder: number
}

export interface SaveBaseConfigInput {
  productType: ItemType
  enabledFilters: SaveBaseConfigEntryInput[]
  /** Filters to switch off. Anything in neither list keeps its saved state. */
  disabledFilters?: string[]
}

export interface FilterOverrideRuleInput {
  filterKey: string
  action: FilterOverrideAction
  displayOrder?: number
}

export interface CreateFilterOverrideInput {
  productType: ItemType
  scopeType: FilterOverrideScope
  scopeId: number
  name?: string
  rules: FilterOverrideRuleInput[]
}

export interface UpdateFilterOverrideInput {
  id: number
  name?: string
  rules: FilterOverrideRuleInput[]
}
